import React from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import { Price } from '@jetshop/ui/Price';
import ProductLink from '@jetshop/ui/ProductLink';
import { theme } from '../Theme';

const Container = styled('div')`
  margin: 1rem 0;
  padding: 1rem 0;
  border-top: 1px solid ${theme.colors.black};
  border-bottom: 1px solid ${theme.colors.black};

  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    padding: 0 0 0.5rem;
  }

  table {
    width: auto;

    th {
      font-weight: bold;
    }

    th,
    td {
      padding: 0.25rem 0.5rem;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
      &.item {
        text-align: left;
      }
      &.qty {
        text-align: center;
      }
      &.total {
        text-align: right;
      }

      a {
        color: ${theme.colors.black};
      }
    }

    .last td {
      padding-bottom: 0.75rem;
    }

    .sum-total {
      font-weight: bold;

      td {
        padding-top: 0.75rem;
        padding-bottom: 0.5rem;
        border-top: 1px solid ${theme.colors.black};
      }
    }
  }
`;

const Item = ({ item, isLast }) => {
  return (
    <tr className={'item' + (isLast ? ' last' : '')}>
      <td className="name">
        <ProductLink product={item.product}>
          {item.product.name}
          {item.variant && <>&nbsp;- {item.variant.values[0]}</>}
        </ProductLink>
      </td>
      <td className="qty">{item.quantity}</td>
      <td className="total">
        <Price price={item.total} />
      </td>
    </tr>
  );
};

const ItemList = ({ cartData }) => {
  // let productList

  return (
    <Container>
      <h3>{t('Your cart')}</h3>
      <table>
        <thead>
          <tr>
            <th className="item">{t('Item')}</th>
            <th className="qty">{t('Quantity')}</th>
            {/*<th className='total'>{t('Total')}</th>*/}
          </tr>
        </thead>

        <tbody>
          {cartData.items.map((item, index) => (
            <Item
              key={item.id}
              item={item}
              isLast={index + 1 === cartData.items.length}
            />
          ))}

          <tr className="sum-total">
            <td>{t('Total')}</td>
            <td className="qty">{cartData.totalQuantity}</td>
            <td className="total">
              <Price price={cartData.productTotal} />
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  );
};

export default ItemList;
